// HEV（Cycle 2）固有の定数。R / L 共通（powertrain で定義される値域のため）。
// 出典: infra `feature` の doc/doc_HEV/HEV対応仕様.md §3。BEV とは別セット（aco は存在しない）。

// gear_id: 1st〜9th, R-range の 10 通り（HEV対応仕様 §3.3）
export const GEAR_IDS = [
    "1st",
    "2nd",
    "3rd",
    "4th",
    "5th",
    "6th",
    "7th",
    "8th",
    "9th",
    "R-range",
] as const;

// 運転モードID（§3.7）。BEV（wot/01g/02g/dec）とは別セット。共通は wot のみ。
export const DRIVE_MODE_IDS = [
    "wot",
    "pot",
    "low_reg",
    "high_reg",
] as const;

// 条件グループID（§3.5）。HEV は gn / vib の 2 種のみ（aco は無い）。
export const CONDITION_GROUP_IDS = ["gn", "vib"] as const;

// 現象ID（§3.6）。条件グループ単位で値域が異なる。
export const PHENOMENON_IDS_BY_GROUP = {
    // gn: planetary gear position 1〜4
    gn: ["gn_pg_PS1", "gn_pg_PS2", "gn_pg_PS3", "gn_pg_PS4"],
    // vib: モーターノイズ振動系（N はリテラル文字）
    vib: ["mn_vib_Nth", "mn_vib_Nx3th", "mn_vib_Nx6th", "mn_vib_Nx9th", "mn_vib_Nx12th"],
} as const;

export const PHENOMENON_IDS = [
    ...PHENOMENON_IDS_BY_GROUP.gn,
    ...PHENOMENON_IDS_BY_GROUP.vib,
] as const;
